// extracted by mini-css-extract-plugin
module.exports = {"QuizContainer":"QuizContainer_QuizContainer__3HGx5","FullWidth":"QuizContainer_FullWidth__3dJzB"};